import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import VenueList from '../components/VenueList';
import VenueDetail from '../components/VenueDetail';
import AddVenueModal from '../components/AddVenueModal';
import API_BASE from '../config/api';

export default function Venues() {
  const { token } = useAuth();
  const [venues, setVenues] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchVenues();
  }, []);

  async function fetchVenues() {
    try {
      const res = await axios.get(`${API_BASE}/api/venues`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setVenues(res.data);
    } catch (err) {
      console.error('Failed to fetch venues:', err);
    } finally {
      setIsLoading(false);
    }
  }

  function handleAdded(venue) {
    setVenues((prev) => [...prev, venue].sort((a, b) => a.name.localeCompare(b.name)));
    setSelectedId(venue._id);
  }

  function handleVenueUpdate(updated) {
    setVenues((prev) =>
      prev.map((v) => (v._id === updated._id ? { ...v, name: updated.name, venue_type: updated.venue_type, city: updated.city, state: updated.state } : v))
    );
  }

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 56px)', overflow: 'hidden' }}>
      {isLoading ? (
        <div style={{
          width: '320px',
          minWidth: '320px',
          borderRight: '1px solid #3a3a3a',
          backgroundColor: '#1a1a1a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <span style={{ color: '#565656', fontFamily: "'Roboto', sans-serif", fontSize: '14px' }}>Loading...</span>
        </div>
      ) : (
        <VenueList
          venues={venues}
          selectedId={selectedId}
          onSelect={setSelectedId}
          onAdd={() => setShowAddModal(true)}
        />
      )}

      <VenueDetail venueId={selectedId} onVenueUpdate={handleVenueUpdate} />

      <AddVenueModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={(venue) => {
          handleAdded(venue);
          setShowAddModal(false);
        }}
      />
    </div>
  );
}
